import { create } from 'zustand';

interface ActivityState {
  activityCount: number;
  pushPermissionGranted: boolean;
  // True once this device's FCM token has been sent to the backend in this
  // session (setDevicePushToken). With OS permission granted, that is what it
  // takes for this device to actually receive a push.
  pushTokenRegistered: boolean;
  pendingPushRoute: string | null;
  setActivityCount: (count: number) => void;
  setPushPermissionGranted: (granted: boolean) => void;
  setPushTokenRegistered: (registered: boolean) => void;
  setPendingPushRoute: (url: string | null) => void;
}

export const useActivityStore = create<ActivityState>((set) => ({
  activityCount: 0,
  pushPermissionGranted: false,
  pushTokenRegistered: false,
  pendingPushRoute: null,
  setActivityCount: (activityCount) => set({ activityCount }),
  setPushPermissionGranted: (pushPermissionGranted) => set({ pushPermissionGranted }),
  setPushTokenRegistered: (pushTokenRegistered) => set({ pushTokenRegistered }),
  setPendingPushRoute: (pendingPushRoute) => set({ pendingPushRoute }),
}));
